import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Sparkle } from "@/components/shared/Motifs";
import { useLanguage } from "@/context/LanguageContext";
import { CONTENT } from "@/i18n/content";
import { cn } from "@/lib/utils";

// Floating navigation shortcut → smooth-scrolls to the Pricing section.
// Not a WhatsApp button. Appears after the user scrolls past the hero.
export function FloatingCTA() {
  const { lang } = useLanguage();
  const label = CONTENT[lang].nav.cta;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () =>
    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="floating-cta"
      aria-label={label}
      className={cn(
        "fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 rounded-full bg-navy px-5 py-3 text-sm font-medium text-cream shadow-[0_12px_30px_-8px_rgba(15,27,61,0.5)] transition-all duration-300 ease-out hover:-translate-y-0.5 hover:bg-navy-dark hover:shadow-[0_16px_36px_-8px_rgba(15,27,61,0.6)] hover:ring-2 hover:ring-gold/50 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:bottom-6 sm:right-6 sm:px-6 sm:py-3.5 sm:text-base",
        visible ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      )}
    >
      <Sparkle size={13} className="text-gold" />
      {label}
      <ArrowRight className="h-4 w-4" />
    </button>
  );
}
